import React, { useEffect, useState } from 'react';
import { Button, Modal, Switch, Collapse } from 'antd';
import { SmileOutlined } from '@ant-design/icons';
import { api } from "../services";
import { useCookieSettings } from "../context/cookieSettingsContext";
import DynamicScriptLoader from "../context/dynamicScriptLoader";

const { Panel } = Collapse;

const CookieSettings = () => {
    const { cookieSettings, setCookieSettings } = useCookieSettings();
    const [visible, setVisible] = useState(false);
    const [cookiePopUp, setCookiePopUp] = useState([]);

    useEffect(() => {
        const fetchCookieData = async () => {
            try {
                const responsePopup = await api.general.getCookiePopup('en');
                const responseCookies = await api.general.getCookies('en');
                setCookiePopUp(responsePopup.data.data);
            } catch (error) {
                console.error('Error fetching cookie data:', error);
            }
        };

        fetchCookieData();
    }, [cookieSettings]);

    const handleSwitchChange = (key, value) => {
        setCookieSettings({ ...cookieSettings, [key]: value });
    };

    const savePreferences = () => {
        setVisible(false);
    };

    return (
        <>
            <DynamicScriptLoader />
            <Button
                type="primary"
                shape="circle"
                icon={<SmileOutlined />}
                size="large"
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    left: '20px',
                    zIndex: 1000,
                    backgroundColor: '#3E77BB',
                    border: 'none',
                }}
                onClick={() => setVisible(true)}
            />

            <Modal
                title="Cookie Settings"
                open={visible}
                onCancel={() => setVisible(false)}
                onOk={savePreferences}
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        onClick={savePreferences}
                        style={{ backgroundColor: 'red', color: '#fff' }}
                    >
                        Save Settings
                    </Button>
                ]}
                centered
                width={500}
            >
                <Collapse bordered={false} defaultActiveKey={['1']}>
                    {cookiePopUp?.map(cookie => (
                        <Panel header={cookie.attributes.title} key={cookie.id}>
                            <p>{cookie.attributes.description}</p>
                            {cookie.attributes.hasCustomizability ? (
                                <Switch
                                    checked={cookieSettings[cookie.attributes.title]}
                                    onChange={(value) => handleSwitchChange(cookie.attributes.title, value)}
                                />
                            ) : (
                                <p></p>
                            )}
                        </Panel>
                    ))}
                </Collapse>
            </Modal>
        </>
    );
};

export default CookieSettings;
